<template>
    <div>

        <el-card style="margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>页面提示数据</span>
            </div>
            <el-table :data="hintMessage">
                <el-table-column prop="userId" label="UserId"></el-table-column>
                <el-table-column prop="email" label="email"></el-table-column>
            </el-table>
        </el-card>

        <el-card>
        <el-form :inline="true">
            <el-form-item label="状态">
                <el-select v-model="queryCondition.status">
                    <el-option v-for="item in transferStatus" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分发显示状态">
                <el-select v-model="queryCondition.businessType">
                    <el-option v-for="item in distributes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间区间：">
                <el-date-picker v-model="queryCondition.time" type="datetimerange" range-separator="至"
                                start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="pageNo = 1,submitQuery()">查询</el-button>
                <el-button type="primary" @click="exportInfo()">导出数据</el-button>
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="showBusinessType" style="margin-left: 150px;">余额变更种类显示</el-checkbox>
            </el-form-item>
        </el-form>
        </el-card>

        <el-table :data="transferInfo">
            <el-table-column prop="id" label="分组" align="center"></el-table-column>
            <el-table-column prop="businessType" label="余额变更种类" v-if="showBusinessType" align="center"></el-table-column>
            <el-table-column prop="userId" label="用户Id" align="center"></el-table-column>
            <el-table-column prop="coinType" label="币种" align="center"></el-table-column>
            <el-table-column prop="availableBalanceChange" label="可用余额" align="center"></el-table-column>
            <el-table-column prop="frozenBalanceChange" label="冻结余额" align="center"></el-table-column>
            <el-table-column prop="time" label="时间" align="center"></el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="transferTotal" :page-size="10"
                       :current-page="pageNo"
                       @current-change="changePage"></el-pagination>
        <br>
        <el-card>
            <el-form>
                <el-form-item>
                    <el-button type="primary" @click="querySuccessAir()">查询空投转账数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-table :data="successListAir">
            <el-table-column prop="description" label="空投描述"></el-table-column>
            <el-table-column label="空投时间">
                <template slot-scope="scope">{{parseDateTime(scope.row.airDropTime)}}</template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="queryDetail(scope.row.id)">查询</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="successTotalAir" :page-size="10"
                       :current-page="successAirQuery.page"
                       @current-change="changePageAir"></el-pagination>

        <el-dialog title="空头转账成功记录" :visible.sync= "showAirRecord" @close="showAirRecord = false">
            <el-table :data="airRecordList">
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="coinType" label="币种"></el-table-column>
                <el-table-column prop="coinAmount" label="金额"></el-table-column>
                <el-table-column prop="coinFroze" label="冻结"></el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next" :total="airRecordTotal" :page-size="10"
                           :current-page="airRecordQuery.page"
                           @current-change="changePageAirRecord"></el-pagination>
            <el-button @click="showAirRecord = false" type="primary">关闭</el-button>
        </el-dialog>

    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import api from './api';
    export default {
        name: "transferQuery",
        data(){
            return{
                queryCondition:{
                    status:'',
                    businessType:'',
                    time:[],
                    startTime:'',
                    endTime:'',
                    page:1,
                },
                transferStatus:[{code:0,desc:'成功'},{code:1,desc:'等待执行'},{code:2,desc:'执行中'},{code:3,desc:'失败'}],
                distributes:[{code:'DISTRIBUTE',desc:'显示'},{code:'DISTRIBUTE_VISIBLE',desc:'隐藏'}],
                pageNo:1,
                showBusinessType:false,
                hintMessage:[
                    {userId:'2019070421473410094000001',email:'airdrop@alpha.vip'},
                    // {userId:'2018060921474251941000004',email:'baifenzhi35@bkex.com'},
                    // {userId:'2019050112000010094000003',email:'cshengou@bkex.vip'},
                    {userId:'2023031414594536416000123',email:'pingzhang@alpha.vip'}
                ],
                successAirQuery:{
                    page:1,
                    taskStatus:2
                },
                successTotalAir:0,
                successListAir:[],
                airRecordQuery:{
                    page:1,
                    airDeopStatus: 2,
                    taskId:''
                },
                airRecordTotal:0,
                airRecordList:[],
                showAirRecord: false
            }
        },
        computed: {
            ...mapState('airdropUpload', ['transferTotal', 'transferInfo'])
        },
        methods:{
            ...mapActions('airdropUpload',['queryTransferList']),
            changePage(pageNo){
                 this.pageNo = pageNo;
                 this.submitQuery();
            },
            submitQuery(){
                this.queryCondition.page = this.pageNo;
                this.queryCondition.startTime = this.queryCondition.time[0];
                this.queryCondition.endTime = this.queryCondition.time[1];
                this.queryTransferList(this.queryCondition);
            },
            exportInfo(){
                this.queryCondition.startTime = this.queryCondition.time[0];
                this.queryCondition.endTime = this.queryCondition.time[1];
                api.exportTransferInfo(this.queryCondition).then(response =>{
                    const fileName = "转账记录信息表.xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            querySuccessAir(){
                api.queryAirDropSuccess(this.successAirQuery).then(response =>{
                    this.successTotalAir = response.data.totalCount;
                    this.successListAir = response.data.list;
                })
            },
            changePageAir(val) {
                this.successAirQuery.page = val;
                this.querySuccessAir();
            },
            parseDateTime(time){
                let now = new Date(time);
                let year=now.getFullYear();
                let month=now.getMonth()+1;
                let date=now.getDate();
                let hour=now.getHours();
                let minute=now.getMinutes();
                let second=now.getSeconds();
                return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            },
            queryAirRecordList(){
                api.queryListAirSuccessRecord(this.airRecordQuery).then(response =>{
                    this.airRecordTotal = response.data.totalCount;
                    this.airRecordList = response.data.list;
                    this.showAirRecord = true;
                })
            },
            changePageAirRecord(val) {
                this.airRecordQuery.page = val;
                this.queryAirRecordList();
            },
            queryDetail(id){
                this.airRecordQuery.taskId = id;
                this.queryAirRecordList();
            }
        },
        created() {
            this.submitQuery();
        }
    }
</script>

<style scoped>

</style>
